module.exports = __webpack_public_path__ + "img/L_320_324.48f6219a.png";